import {
	reInfoOrgConstants
}from "./constants"
import actions from '../../actions'

const initialState = {
	changed   : null,
	paged     : {},
	list      : [],
	isSending : false
}

export default function (state = initialState, action){
	switch (action.type){
		case reInfoOrgConstants.GetPaged.REQUEST:
		case reInfoOrgConstants.GetList.REQUEST:
		case reInfoOrgConstants.GetListByRoles.REQUEST:
		case reInfoOrgConstants.Create.REQUEST:
		case reInfoOrgConstants.Delete.REQUEST:
		case reInfoOrgConstants.Restore.REQUEST:
		case reInfoOrgConstants.Update.REQUEST:
		case reInfoOrgConstants.Upload.REQUEST:
		case reInfoOrgConstants.GetExampleFile.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reInfoOrgConstants.GetPaged.FAILURE:
		case reInfoOrgConstants.GetList.FAILURE:
		case reInfoOrgConstants.GetListByRoles.FAILURE:
		case reInfoOrgConstants.Create.FAILURE:
		case reInfoOrgConstants.Delete.FAILURE:
		case reInfoOrgConstants.Restore.FAILURE:
		case reInfoOrgConstants.Update.FAILURE:
		case reInfoOrgConstants.Upload.FAILURE:
		case reInfoOrgConstants.GetExampleFile.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reInfoOrgConstants.GetExampleFile.SUCCESS:{
			return {
				...state,
				isSending: false
			}
		}
		case reInfoOrgConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reInfoOrgConstants.GetList.SUCCESS:
		case reInfoOrgConstants.GetListByRoles.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reInfoOrgConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reInfoOrgConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reInfoOrgConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reInfoOrgConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reInfoOrgConstants.Upload.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.download : null
			}
		case reInfoOrgConstants.CLEAR:
			return {
				...state,
				changed   : null,
				isSending : false,
				paged     : {},
				list      : []
			}
		default:
			return state
	}
}